module.exports = __webpack_public_path__ + "static/media/upload-material-en.63f5eb6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/upload-material-en.png
// module id = 1165
// module chunks = 110